import { COMING_SOON, OUT_OF_STOCK } from "@/core/constants";
import ChevronComponent from "@/tpo/Chevron";
import ButtonV2 from "@/v2/Buttons";

export default function AddToBasketButton({
  practitionerSupportRequired,
  hasClinics,
  onFindNearestClinic,
  onAddToBasket,
  status,
  disabled,
  disabledMessage,
  color: colorProp,
  text: specifiedText
}) {
  const hasClinicSelectionFlow = hasClinics && !!onFindNearestClinic;

  let text = practitionerSupportRequired
    ? "practitioner only"
    : hasClinicSelectionFlow
    ? "find nearest clinic"
    : "add to basket";
  if (status === OUT_OF_STOCK) text = "Out of stock";
  if (status === COMING_SOON) text = "Coming soon";

  if (disabled) {
    text = disabledMessage || text;
  }

  disabled =
    disabled || practitionerSupportRequired || status === OUT_OF_STOCK || status === COMING_SOON;

  const color = colorProp || (disabled ? "midGrey" : "green");

  return (
    <ButtonV2
      color={color}
      rightIcon={disabled ? null : <ChevronComponent />}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        if (hasClinicSelectionFlow) {
          onFindNearestClinic();
        } else if (onAddToBasket) {
          onAddToBasket();
        }
      }}
      style={{
        opacity: !disabled || (disabled && color === "midGrey") ? 1 : 0.5
      }}
      size={["sm", "sm", "md"]}
    >
      {specifiedText || text}
    </ButtonV2>
  );
}
